export default __webpack_public_path__ + "static/media/logoAplique.ff0ca692.png";